<template>
    <div class="member-amount">
        <alart-msg :display="alart.success" styleType="success" @alartStatus="alart.success = false">
            <span class="title" slot="title">{{msg.success}}</span>
        </alart-msg>
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.fail}}</span>
        </alart-msg>
        <!-- <modal class="withdraw-modal" :display="withdrawModal"  @modalStatus="closeModal('withdraw')" >
            <h1>輸入提領金額</h1>
            <div class="content" v-if="withdrawState == 0">
                <div class="name">
                    <span>可提領餘額</span>
                    <div class="money">
                        <span class="sign">
                            $
                        </span>
                        <div class="number">
                            {{toCurrency(amount.toFixed(2))}}
                        </div>
                    </div>
                </div>
                <div class="price">
                    <span>提領金額</span>
                    <div class="input-error-group">
                        <input type="text" v-model="withdraw.price" >
                        <span v-show="error.withdraw" class="error">{{error.withdraw}}</span>
                    </div>
                </div>
                <div class="bank" >
                    <span>選擇提領帳戶</span>
                    <rent-select :key="componentKey" refName="bank" :selectMsg="defaultBankName" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li :data-id="card.bankAccountCid" :data-name="card.bankName.bankName" :data-acc="bankAccountEncrypt(card.accountNo)" v-for="(card,index) in bankCardList" :key="index">
                                {{card.bankName.bankName}}帳戶 （ {{bankAccountEncrypt(card.accountNo)}}）
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="content" v-if="withdrawState == 1">
                <div class="list">
                    <span class="title">申請時間</span>
                    <span class="info">{{today}}</span>
                </div>
                <div class="list">
                    <span class="title">轉入帳號</span>
                    <span class="info">{{seletedBank.name}}帳戶 （ {{seletedBank.account}}）</span>
                </div>
                <div class="list">
                    <span class="title">提領金額</span>
                    <span class="info">$ {{toCurrency(withdraw.price)}}</span>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" v-if="withdrawState == 0" :disabled="disabledState" @click="withdrawState=1">下一步</button>
                <button class="default-button" v-if="withdrawState == 1" @click="withdrawAmount">確認提領</button>
                <button class="border-button" @click="closeModal('withdraw')">取消</button>
            </div>
        </modal> -->
        <!-- <modal class="info-modal" :display="infoModal"  @modalStatus="closeModal('infoModal')" >
            <h1>平台收費說明</h1>
            <div class="content">
                <p>
                    委託獎金：委託獎金*20%，為平台服務費。<br>
                    委託成功，平台將發放80%獎金予受託人。<br>
                    委託失敗，平台將退還80%獎金予房東。
                </p>
                <p>
                    其他費用：費用金額*2%，為平台代收服務費，<br>
                    包含定金、押金、租金或其他新增費用。<br>
                    ( 帳戶餘額已扣除平台服務費 )
                </p>
            </div>
        </modal> -->
        <add-nick-name :noClose="false"></add-nick-name>
        <div class="edit-wrap">
            <div class="member-shot">
                <img v-if="userShot" class="shot" :src="userShot" alt="">
                <img v-else class="shot" src="@/assets/img/shot.svg" alt="">
                
            </div>
            <file-upload
                class="edit"
                post-action="/upload/post"
                :size="1024 * 5"
                :maximum="1"
                :multiple="true"
                :drop="true"
                :drop-directory="true"
                v-model="files"
                @input-file="inputFile"
                @input-filter="inputFilter"
                ref="upload">
                    <img src="@/assets/img/icon/shot_edit_green.svg" alt="" srcset="">
            </file-upload>
            
        </div>
        <div class="amount">
            <div class="name" @click="editNickName()" :class="{'active': nickNameIsHover}" @mouseenter="nickNameIsHover = true" @mouseleave="nickNameIsHover = false">
                {{landlordName}}
                <img src="@/assets/img/icon/nickname_edit.svg" alt="">
            </div>
            <!-- <div class="money">
                <span class="sign">
                    帳戶餘額
                </span>
                <div class="number">
                    {{toCurrency(amount)}}
                </div>
            </div> -->
        </div>
        <div class="btn-group">
            <!-- <div class="title" @click="infoEvent(), $analytics.logEvent('平台收費說明', { screen_name: '平台收費說明'})">
                <img src="@/assets/img/icon/info_gray.svg" alt="" srcset="" @mouseenter="infoShow = 1" @mouseleave="infoShow = 0">
                <span class="info">平台收費說明</span>
            </div> -->
            <!-- <button class="border-button withdraw" @click="withdrawEvent(),componentKey += 1;" @mouseenter="dolarImg.now = dolarImg.hover" @mouseleave="dolarImg.now = dolarImg.default">
                提領
            </button> -->
        </div>
        
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import addNickName from '@/components/widge/addNickName.vue';
import FileUpload from 'vue-upload-component';
import { mapGetters } from 'vuex'

import { 
    apiGetBalance,
    apiWithwraw,
    apiSetUserShot
} from "@/apis/api.js"; 

export default {
    data () {
        return {
            defaultBankName: null,
            componentKey: 0,
            bankCardList: [],
            amount: 0,
            infoShow: 0,
            disabledState: true,
            isDefault: false,
            withdrawState: 0,
            withdrawModal: false,
            infoModal: false,
            nickNameIsHover: false,
            seletedBank: {
                name: null,
                account: null,
            },
            withdraw:{
                price: null,
                account: null
            },
            error:{
                withdraw: ''
            },
            dolarImg: {
                now: require('@/assets/img/icon/dollar_green.svg'),
                default: require('@/assets/img/icon/dollar_green.svg'),
                hover: require('@/assets/img/icon/dollar_orange.svg')
            },
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                fail: null,
            },
            files: []
        }
    },
    mounted () {
        this.getBalance()
        this.getBankCardList()
    },
    watch: {
        withdraw: {
            handler: function (newValue, oldValue) {
                let numerical = /^[0-9]*$/
                if(newValue.price){
                    if( numerical.test(newValue.price) ){
                        this.error.withdraw = ''
                        if( newValue.price > this.amount){
                            this.error.withdraw = '餘額不足'
                        }else if(newValue.price > 100000){
                            this.error.withdraw = '最大提領金額為10萬'
                        }else{
                            this.error.withdraw = ''
                        }
                    }else{
                        this.error.withdraw = '請輸入數字'
                    }
                }
                // 房租
                if( newValue.price && newValue.account && !this.error.withdraw){
                    this.disabledState = false
                }else{
                    this.disabledState = true
                }
                // this.$store.dispatch('setHouseList',newValue)
            },
            deep: true
        },
        bankCardList: {
            handler: function (val) {
                // console.log(val)
                this.defaultBankInfo(val)
            },
            deep: true
        },
        files: {
            handler: function (val) {
                if(val.length){
                    this.setUserShot()
                }
            },
            deep: true
        }
    },
    methods: {
        getBalance: function () {
            apiGetBalance()
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    this.amount = res.data.result.balance
                }else{
                    this.amount = 0
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getBankCardList: function () {
            // this.$store.dispatch('getBankCardList')
            apiGetBankCard()
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    this.bankCardList = res.data.result.bankInfoList
                    this.defaultBankInfo(this.bankCardList)
                }
            })
            .catch(err =>{
                console.log(err)
            })
        },
        defaultBankInfo: function (bankList) {
            bankList.map( item =>{
                if(item.isDefaultBankAccount == true){
                    this.componentKey += 1;
                    this.withdraw.account = item.bankAccountCid
                    this.defaultBankName = item.bankName.bankName+'（'+ this.bankAccountEncrypt(item.accountNo) +'）'
                    this.seletedBank.account = this.bankAccountEncrypt(item.accountNo)
                    this.seletedBank.name = item.bankName.bankName
                }
            })
        },
        withdrawAmount: function () {
            this.$analytics.logEvent('送出提領', { screen_name: '送出提領'})
            let data = {
                "bankAccountId" : this.withdraw.account,
                "currencyType" : "TWD",
                "withdrawAmount" : this.withdraw.price
            }

            apiWithwraw(data)
            .then(res => {
                // console.log(res)
                if(res.data.status == "SUCCESS"){
                    this.closeModal('withdraw')
                    this.getBalance()
                    this.alart.success = true
                    this.msg.success = '提領審核中'
                    this.$store.dispatch('getTransRecord')
                }else{
                    this.alart.fail = true
                    this.msg.fail = res.data.errorMsg
                    this.closeModal('withdraw')
                }
            })
            .catch(err => {
                this.alart.fail = true
                this.msg.fail = err
                console.log(err)
            })
        },
        getSelectId: function (value) {
            this.isDefault = false
            if( value.ref == 'bank' ){
                this.withdraw.account = event.target.dataset.id
                this.seletedBank.name = event.target.dataset.name
                this.seletedBank.account = event.target.dataset.acc
            }
        },
        withdrawEvent: function () {
            if(this.amount > 0){
                this.withdrawModal = true
                document.getElementsByClassName('member-center')[0].style.zIndex = '9'
                this.$store.commit('modalStatus/set_modal_mode', true)
            }else{
                let data = {
                    type: 'error',
                    msg: '餘額不足'
                }
                this.$store.dispatch('setAlarmMsg',data)
            }
        },
        infoEvent: function () {
            document.getElementsByClassName('member-center')[0].style.zIndex = '9'
            this.$store.commit('modalStatus/set_modal_mode', true)
            this.infoModal = true

        },
        closeModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', false)
            document.getElementsByClassName('member-center')[0].style.zIndex = '8'
            if( type == 'withdraw' ){
                this.withdrawModal = false
                this.withdrawState = 0
                this.withdraw.price = null
                this.withdraw.account = null
            }else if( type == 'infoModal' ){
                this.infoModal = false
            }
        },
        editNickName: function () {
            this.$analytics.logEvent('編輯出租人姓名', { screen_name: '編輯出租人姓名'})
            document.getElementsByClassName('member-center')[0].style.zIndex = '9'
            this.$store.dispatch('setModalStatus', {state: true, type: 'addNickName'})
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        bankAccountEncrypt: function (account) {
            return '*****'+account.substr(5)
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
        
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.fail = '請上傳JPG或PNG檔案'
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.fail = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        setUserShot: function () {
            let formData = new FormData();
            console.log(this.files)
            formData.append('file', this.files[0].file);

            apiSetUserShot(formData)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    // this.$store.dispatch('getUserStatus')
                    location.reload();
                }
            })
        }
    },
    computed:{
        today: function () {
            if(this.withdrawState == 1){
                var formatDate = [];
                var date = new Date();
                //一般日期 年 月 天 時 分
                formatDate[0] = date.getFullYear();
                formatDate[1] = date.getMonth()+1;
                formatDate[2] = date.getDate();
                formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
                formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
                formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
                //月及天兩位數
                formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
                formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
                // console.log(formatDate[3] )
                //換算時區 台灣-8
                // if(formatDate[3] - 8 < 0){
                //     formatDate[3] = 24+(formatDate[3]-8);
                //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
                // }else{
                //     formatDate[3] = formatDate[3]-8;
                //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
                // }
                return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4]+':'+formatDate[5];
            }
        },
        landlordName: function () {
            
            let nickName = this.userDetail?this.userDetail.nickName:null
            if(nickName){
                return nickName
            }else{
                return '編輯出租人姓名'
            }
        },
        ...mapGetters({
            // bankCardList: 'GET_MEMBER_BANK_CARD_LIST',
            userDetail: 'GET_USER_DETAIL',
            userShot: 'GET_VERIFIED_USER_SHOT'
        })
    },
    components: {
        RentSelect,
        Modal,
        AlartMsg,
        addNickName,
        FileUpload,
    }
}
</script>
<style lang="scss" scoped>
    .member-amount{
        position: relative;
        width: 1154px;
        display: flex;
        align-items: center;
        margin-top: 40px;
        margin-bottom: 60px;
        .money{
            position: relative;
            display: flex;
            align-items: center;
            .sign{
                font-size: 12px;
                color: #676362;
            }
            .number{
                color: #ff9275;
                margin-left: 6px;
                font-size: 28px;
            }
        }
        .edit-wrap{
            position: relative;
            .member-shot{
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 26px;
                box-shadow: 0px 2px 4px rgba(165, 166, 187, 0.2);
                width: 78px;
                height: 78px;
                overflow: hidden;
                border-radius: 50%;
                .shot{
                    width: 78px;
                }
            }
            .edit{
                position: absolute;
                right: 20px;
                bottom: 0px;
                >label{
                    cursor: pointer;
                }
            }
        }
        .amount{
            .name{
                display: flex;
                align-items: center;
                font-size: 20px;
                font-weight: 500;
                padding-bottom: 4px;
                margin-bottom: 7px;
                border-bottom: 1px solid  #e0dfde;
                width: fit-content;
                cursor: pointer;
                img{
                    display: none;
                    margin-left: 8px;
                }
            }
            .name.active{
                border-bottom: 1px solid  #ff9275;
                cursor: pointer;
                img{
                    display: flex;
                }
            }
        }
        >.btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            right: 0px;
            .title{
                display: flex;
                align-items: center;
                font-size: 12px;
                margin-right: 20px;
                cursor: pointer;
                .info{
                    height: 24px;
                    font-size: 12px;
                    line-height: 24px;
                    color: #676362;
                    border-radius: 2px;
                }
                img{
                    margin-right: 2px;
                }
            }
            .withdraw{
                width: 120px;
                height: 44px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        
        .withdraw-modal{
            .modal-content{
                width: 448px;
                padding: 0 !important;
                .detail{
                    align-items: unset !important;
                    h1{
                        margin: 0 auto;
                        margin-top: 36px;
                        margin-bottom: 24px;
                    }
                    .alarm-msg{
                        padding: 8px 32px;
                        margin-bottom: 30px;
                        font-size: 16px;
                        font-weight: 500;
                        color: #fc7171;
                        background-color: rgba(240, 90, 62, 0.1);
                        line-height: 1.7;
                    }
                    .content{
                        min-height: 336px;
                        padding: 0 32px 10px 32px;
                        // margin-bottom: 52px;
                        >div{
                            margin-bottom: 30px;
                            >span{
                                display: block;
                                margin-bottom: 12px;
                            }
                            input{
                                width: 352px;
                            }
                        }
                        .price{
                            margin-bottom: 48px;
                        }
                        .bank{
                            span{
                                color: #676362 !important;
                            }
                        }
                        .list{
                            display: flex;
                            margin-bottom: 20px;
                            .title{
                                display: block;
                                width: 56px;
                                color: #a8a5a4;
                                margin-right: 22px;
                            }
                        }
                        .money{
                            position: relative;
                            display: flex;
                            align-items: flex-end;
                            color: #ff9275;
                            .sign{
                                position: absolute;
                                font-size: 12px;
                                font-weight: 500;
                                bottom: 5px;
                                color: #ff9275;
                            }
                            .number{
                                margin-left: 12px;
                                font-size: 32px;
                            }
                        }
                    }
                    .content::-webkit-scrollbar {
                        display: none;
                    }
                    .btn-group{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 84px;
                        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                        border-radius:  0 0 20px 20px;
                        margin: 0 auto;
                        button{
                            width: 184px;
                            height: 44px;
                        }
                        button:first-child{
                            margin-right: 14px;
                        }
                    }
                }
                
            }
        }
        // .info-modal{
        //     .modal-content{
        //         width: 448px;
        //         padding: 0 !important;
        //         .detail{
        //             align-items: unset !important;
        //             padding: 32px 0;
        //             h1{
        //                 margin: 0 auto;
        //                 margin-bottom: 24px;
        //             }
        //             .content{
        //                 p{
        //                     font-weight: 300;
        //                     line-height: 1.71;
        //                     text-align: center;
        //                 }
        //             }
        //         }
        //     }
        // }
    }
    @media screen and (max-width: 1280px) {
        .member-amount{
            .withdraw{
                right: 11px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/MemberAmount.vue